<template>
    <div id="container" type="vnotsellpersonalinfo">
        <div class="page personal-info"  v-ga:request="{pageType:'vnotsellpersonalinfo', state: {}}" v-ga:page="{pageType:'vnotsellpersonalinfo', glb: glb, state: {}}">
            <mvtHeader />
            <div class="static-section">
                <div class="static-gs">
                    <div class="h3 info">
                        Do not sell my personal information
                    </div>
                    <div>
                    <p>
                        As set forth in more detail in our
                        <span>
                            <a class="link" :href="`${glb.appUrl}about/privacy-policy/`">Privacy Policy</a>
                        </span>
                        Privacy Policy (including the
                        <span>
                            <a class="link" :href="`${glb.appUrl}about/ca_privacy/`">Privacy Notice for California Residents</a>
                        </span>)
                        , we may share your personal information with our affiliates, advertising partners and other third parties (including our lead referral partners).  Our affiliates, advertising partners and certain other third parties (including lead referral partners) use and may also further share this information for their own purposes. For more details, please see our
                        <span>
                            <a class="link" :href="`${glb.appUrl}about/ca_privacy/`">Privacy Notice for California Residents</a>
                        </span>.
                    </p>
                </div>
                <div>
                    <p>
                        Applicable law (including, without limitation, the California Consumer Privacy Act) may consider some of this information sharing to be a “sale” and gives consumers (including residents of the state of California) the right to prevent businesses from selling their personal information. If you do not wish for us or our third-party partners to sell your personal information to others for such purposes, please indicate your preferences by clicking the “Opt Out” button provided below. We will act upon your opt-out request as soon as feasibly possible, but no later than 15 days from the date of your request.
                    </p>
                </div>
                <div>
                    <p>
                        If you access this site from other devices or browsers, or clear your cookies on your devices or browsers, you will need to indicate your preferences again from those devices or browsers. Please note that after making your “Do Not Sell” request, you may still see advertising and we may continue to share personal information with our service providers who use such information on our behalf. To learn more about interest-based advertising across sites and additional opt-out choices, you can visit <span>
                            <a class="link" href="http://optout.aboutads.info">http://optout.aboutads.info</a>
                        </span> and <span>
                            <a class="link" href="http://optout.networkadvertising.org">http://optout.networkadvertising.org</a>
                        </span>
                    </p>
                </div>
                <div class="optout">
                    <a class="btn primary regular width-fixed" @click="optout()" href="javascript:void(0)">Opt Out</a>
                </div>
                <div>
                    <p>
                        If you change your mind simply clear the cookies in your browser.
                    </p>
                </div>
                </div>
            </div>
            <mvtFooter />
            <mvtDialogCenter></mvtDialogCenter>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mvtDialogCenter from "@/common/components/mvtdialogcenter/mvt-dialogcenter.vue";

export default {
    name: 'personalInfo',
  components: {mvtDialogCenter},
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb'])
    },
    methods: {
        optout: function() {
            this.$eventBus.$emit('dialog-open-contactus');
        }
    },
};

</script>

<style lang="scss">
@use './personal-info.scss' as *;
</style>